<template>
  <MoleculeFrameCard spacing="sm" main-theme="dark">
    <div class="flex items-start justify-between mb-3" :data-cy="dataCy">
      <AtomPicto :name="pictoName" size="sm" />

      <MoleculeButton
        :data-cy="dataCy ? `${dataCy}-edit` : undefined"
        :aria-label="`${t('subscription.informationsSummary.edit')} ${title}`"
        @click="emit('edit', editStep)"
        variant="minimal"
        icon-name="PencilIcon"
        icon-type="solid"
        size="xs"
      />
    </div>

    <div>
      <AtomText :text="title" font-size="text-sm" font-style="font-bold" />

      <AtomText
        v-if="subtitle"
        class="mt-1"
        :text="subtitle"
        font-size="text-sm"
        color-variant="description"
      />

      <div class="mt-1 leading-none">
        <MoleculeTag
          :key="index"
          class="m-0.5"
          size="lg"
          v-for="(tag, index) in tags"
          :value="tag.text"
          :type="tag.type ?? 'offers'"
          :iconName="tag.iconName"
          variant="icon"
        />
      </div>
    </div>
  </MoleculeFrameCard>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import type { SubscriptionRouteName } from '@/types/router.type';

type Tag = {
  text: string;
  iconName: string;
  type?: 'offers' | 'economy';
};

defineProps<{
  title: string;
  subtitle?: string;
  pictoName?: string;
  tags?: Array<Tag>;
  dataCy?: string;
  editStep: SubscriptionRouteName;
}>();

const emit = defineEmits<{ edit: [step: SubscriptionRouteName] }>();

const { t } = useI18n();
</script>
